import { useState } from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography } from '@mui/material';
import CustomModal from 'src/components/modal/customModal';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled, useTheme } from '@mui/material/styles';
import { allowedCountries, ROUTE, PLAN_TYPE } from 'src/lib/Enums';
import { checkButtonAccess } from 'src/utils/common';
import { axiosGetCall, axiosPostCall } from 'src/services/apisCall';

const RowTow = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));


const VoicePlansModal = ({ openModal, forceLoad, loadit, handleCloseModal, title, edit, data }) => {
    const theme = useTheme();
    const inputSx = {
        color: theme.palette.text.primary,
        // borderColor: 'grey.700',
        borderRadius: "6px",
        height: '55px'
    };

    const [country, setCountry] = useState(edit ? data?.country : '');
    const [planName, setPlanName] = useState(edit ? data?.plan_name : '');
    const [route, setRoute] = useState(edit ? data?.route : '');
    const [pulse, setPulse] = useState(edit ? data?.pulse : '');
    const [pulseRate, setPulseRate] = useState(edit ? data?.pulse_rate : '');
    const [type, setType] = useState(edit ? data?.type : '');

    const [error, setError] = useState({});

    const handleChange = async (e) => {
        e.preventDefault();
        const errorTemp = {};
        if (!country) {
            errorTemp.country = "Country is required";
        }
        if (!route) {
            errorTemp.route = "Route is required";
        }
        if (!type) {
            errorTemp.type = "Type is required";
        }
        if (!pulse) {
            errorTemp.pulse = "pulse is required";
        }
        if (!pulseRate) {
            errorTemp.pulseRate = "pulseRate is required";
        }
        if (!planName) {
            errorTemp.planName = "planName is required";
        }
        setError(errorTemp);
        if (Object.keys(errorTemp).length === 0) {
            try {
                const { message } = await axiosGetCall("addVoicePlans", { countryCode: country, route, planName: planName, pulseRate,pulse });
                renderSuccessMessage(message);
                handleCloseModal();
                forceLoad(!loadit)
                setCountry('')
                setPlanName('')
                setRoute('')
                setPulse('')
                setPulseRate('')
                setType('')
                setError({})
            } catch (error) {

                renderErrorMessage(error?.message);
            }
        }
    };
    const description = (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '25px',
                width: '100%',
                padding: '25px'
            }}
            noValidate
            autoComplete="off"
        >
            <RowTow>
                <FormControl fullWidth error={error.route}>
                    <InputLabel id="demo-simple-select-label">PlanType</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={type}
                        label="Country*"
                        onChange={(e) => setType(e.target.value)}
                        name="type"
                    >
                        {Object.entries(PLAN_TYPE).map(([code, planType]) => (
                            <MenuItem key={code} value={code}>{planType}</MenuItem>
                        ))}

                    </Select>
                </FormControl>
                </RowTow>
               {type === 'A' ? (
                   <>
                         <RowTow>
                    <FormControl fullWidth error={error.route}>
                        <TextField
                            fullWidth
                            label="Plan Name"
                            type='text'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={planName}
                            onChange={(e) => setPlanName(e.target.value)}
                            size="small"
                        />

                        {error.planName && <FormHelperText>{error.planName}</FormHelperText>}
                    </FormControl>
                    <FormControl fullWidth error={error.route}>
                        <InputLabel id="demo-simple-select-label">Route</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={route}
                            label="route*"
                            onChange={(e) => setRoute(e.target.value)}
                            name="route"
                        >
                            {Object.entries(ROUTE).map(([code, Route]) => (
                                <MenuItem key={code} value={code}>{Route}</MenuItem>
                            ))}

                        </Select>
                        {error.route && <FormHelperText>{error.route}</FormHelperText>}
                    </FormControl>
                </RowTow>
                <RowTow>
                    <FormControl fullWidth error={error.country}>
                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={country}
                            label="Country*"
                            onChange={(e) => setCountry(e.target.value)}
                            name="Country"
                        >
                            {Object.entries(allowedCountries).map(([code, country]) => (
                                <MenuItem key={code} value={code}>{country}</MenuItem>
                            ))}

                        </Select>
                        {error.country && <FormHelperText>{error.country}</FormHelperText>}
                    </FormControl>


                </RowTow>
                <RowTow>
                    <FormControl fullWidth error={error.route}>
                        <TextField
                            fullWidth
                            label="Pulse"
                            type='text'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={pulse}
                            onChange={(e) => setPulse(e.target.value)}
                            size="small"
                        />

                        {error.pulse && <FormHelperText>{error.pulse}</FormHelperText>}
                    </FormControl>
                    <FormControl fullWidth error={error.route}>
                        <TextField
                            fullWidth
                            label="Pulse Rate"
                            type='text'
                            variant="outlined"
                            InputProps={{
                                sx: inputSx,
                            }}
                            value={pulseRate}
                            onChange={(e) => setPulseRate(e.target.value)}
                            size="small"
                        />

                        {error.pulseRate && <FormHelperText>{error.pulseRate}</FormHelperText>}
                    </FormControl>
                </RowTow>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    pt: '10px',
                    pb: '20px'
                }}>
                    <LoadingButton
                        variant='outlined'
                        onClick={(e) => handleChange(e)}
                        disabled={!checkButtonAccess("addUpdateVoicePlans", "w")}
                    >
                        {edit ? "Update" : "Create"}
                    </LoadingButton>
                </Box>
                   </>
               ):<RowTow>
                <Typography sx={{color: 'green'}}>This feature is yet to be released on CA. For further use, please go to the PHP panel.</Typography>
                </RowTow>}
            
            
        </Box>
    );

    return openModal && (
        <CustomModal
            open={openModal}
            title={title}
            description={description}
            close={handleCloseModal}
            isCloseIcon={true}
        />
    );
};
export default VoicePlansModal;